// STYLES
import * as Style from "./ConfirmationModalStyle";

// LIBRARIES

// MISC
import { IProps } from "./ConfirmationModalModel";
import { ButtonTypes } from "models/GeneralTypes/generalTypes";

// ASSETS

// REDUX
import { useAppDispatch } from "hooks/reduxHooks";
import { toggleModalState } from "slices/uiSlice";

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";

const ConfirmationModal = (props: IProps) => {
  // PROPS
  const { handleClose = () => {} } = props;

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleDeleteDiscount = () => {
    dispatch(
      toggleModalState({
        isVisible: false,
        type: null,
        discount: null,
      })
    );
  };

  return (
    <Style.ConfirmationModalContainer>
      <Style.HeaderContainer>Confirmare</Style.HeaderContainer>
      <Style.TextContainer>
        Esti sigur ca vrei sa stergi acest discount?
      </Style.TextContainer>
      <Style.ButtonsWrapper>
        <ButtonAtom
          onClick={handleClose}
          text="Renunta"
          type={ButtonTypes.SECONDARY_BUTTON}
          width="110px"
        />
        <ButtonAtom
          onClick={handleDeleteDiscount}
          text="Stergeti"
          type={ButtonTypes.THIRD_BUTTON}
          width="110px"
        />
      </Style.ButtonsWrapper>
    </Style.ConfirmationModalContainer>
  );
};

export default ConfirmationModal;
